export const dateTimeFromString = (value) => {
  const date = value?.slice(0, 10).split('-') || ''
  const dateFormatted = `${date[2]}/${date[1]}`

  const time = value?.slice(11, 19).split(':') || ''
  const timeFormatted = `${time && time[0]}:${time && time[1]}`

  return `${dateFormatted} às ${timeFormatted}`
}
